import { NonEligibleContributionTypeIds } from 'modules/Constants'

export const isEligibleContributionType = (typeId) =>
    !NonEligibleContributionTypeIds.includes(Number(typeId))

export const getEligibleContributions = (contributions) =>
    (contributions || []).filter(c => c && !c.isDeleted && c.contributionTypeId && isEligibleContributionType(c.contributionTypeId))

/**
 * Splits percentage evenly, giving remainder to last item
 * e.g., (100, 3) => [33.33, 33.33, 33.34]
 */
export const splitPercentageEvenly = (total, count) => {
    if (count <= 0) return []
    const base = Math.floor((total / count) * 100) / 100
    const result = Array(count).fill(base)
    result[count - 1] = Math.round((total - base * (count - 1)) * 100) / 100
    return result
}

export const calculateMinutesWorked = (percentage, duration) =>
    duration > 0 ? Math.round((percentage / 100) * duration * 100) / 100 : 0
